import { HmfButtonComponent, HmfSkeletonComponent } from '@dsg-tech/homefield-angular';
import { HmfCarouselComponent, HmfProductCardComponent } from '@dsg-tech/homefield-angular-cdk';

import { CommonModule } from '@angular/common';
import { DSProductRecommendationsComponent } from './ds-product-recommendations.component';
import { NgModule } from '@angular/core';
import { ProductRecommendationsService } from '@product-recommendations/data-access';
import { ProductService } from '@shared/data-access/services';
import { ResizeEventsDirective } from '@shared/utils/directives';

@NgModule({
	declarations: [DSProductRecommendationsComponent],
	imports: [
		CommonModule,
		HmfButtonComponent,
		HmfCarouselComponent,
		HmfProductCardComponent,
		HmfSkeletonComponent,
		ResizeEventsDirective
	],
	providers: [ProductRecommendationsService, ProductService],
	exports: [DSProductRecommendationsComponent]
})
export class DSProductRecommendationsModule {}
